import { render, staticRenderFns } from "./SelectBankingInfo.vue?vue&type=template&id=38b3ed67&scoped=true"
import script from "./SelectBankingInfo.vue?vue&type=script&lang=js"
export * from "./SelectBankingInfo.vue?vue&type=script&lang=js"
import style0 from "./SelectBankingInfo.vue?vue&type=style&index=0&id=38b3ed67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3ed67",
  null
  
)

export default component.exports